// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"52350fab","821":"5872e8f3"}[chunkId] + ".chunk.js";
};